export const withLoadingApi = (api, loadProp, vueObj, index ) => {
  let isArray = Array.isArray(loadProp);
  if(isArray && loadProp[index] || !isArray && vueObj[loadProp]) return;
  isArray
  ? vueObj.$set(loadProp, index, true)
  : vueObj.$set(vueObj, loadProp, true);
  return new Promise((resolve, reject) => {
    api.then(res => {
      resolve(res);
    }).catch(err => {
      reject(err);
    }).finally(() => {
      isArray
      ? vueObj.$set(loadProp, index, false)
      : vueObj.$set(vueObj, loadProp, false);
    })
  })
}

export const withAwait = (func) => {
  return func instanceof Promise
  ? new Promise((resolve) => {
    func.then(res => {
      resolve([res, null])
    }).catch(err => {
      resolve([null, err])
    })
  })
  : [null, null]
}



// WEBPACK FOOTER //
// ./src/utils/hoc.js